import { Injectable } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import {
  ConnectionHttpService,
  ApiResourceLocation,
  ResponseRequestEvent,
} from '@softline/core';
import { Observable } from 'rxjs';
import { map, toArray } from 'rxjs/operators';
import { SIGNATURE_RESOURCE_PATH } from '../arbeitsschein.api';

@Injectable()
export class SignatureService {
  constructor(
    private service: ConnectionHttpService,
    private sanitizer: DomSanitizer
  ) {}

  getSignatureImage(encodedSignature: string): Observable<SafeUrl> {
    const location: ApiResourceLocation = {
      path: `${SIGNATURE_RESOURCE_PATH}/${encodedSignature}`,
    };
    return this.service.download(location).pipe(
      map(o => o as ResponseRequestEvent<Blob>),
      toArray(),
      map((response: ResponseRequestEvent<Blob>[]) => {
        const responseEvent = response[response?.length - 1] ?? undefined;
        const objectURL = URL.createObjectURL(
          responseEvent?.response ?? new Blob()
        );
        return this.sanitizer.bypassSecurityTrustUrl(objectURL) ?? '';
      })
    );
  }
}
